// Weight category special values
export const WEIGHT_CATEGORY = {
	HEAVY: 'heavy',
	UNKNOWN: 'unknown',
} as const;

// Weight option type
export interface WeightOption {
	label: string;
	value: string;
	weight: number | null;
	unit: 'kg' | 'g' | null;
}

// International parcel options (8)
export const INTERNATIONAL_PARCEL_OPTIONS: WeightOption[] = [
	{ label: '0-500 g', value: '0-500g', weight: 0.5, unit: 'kg' },
	{ label: '501-1000 g', value: '501-1000g', weight: 1, unit: 'kg' },
	{ label: '2 kg', value: '2kg', weight: 2, unit: 'kg' },
	{ label: '3 kg', value: '3kg', weight: 3, unit: 'kg' },
	{ label: '4 kg', value: '4kg', weight: 4, unit: 'kg' },
	{ label: '5 kg', value: '5kg', weight: 5, unit: 'kg' },
	// 'heavy' and 'unknown' are added dynamically with translated labels
];

// Domestic parcel options (6)
export const DOMESTIC_PARCEL_OPTIONS: WeightOption[] = [
	{ label: '0-2 kg', value: '0-2kg', weight: 2, unit: 'kg' },
	{ label: '3-5 kg', value: '3-5kg', weight: 5, unit: 'kg' },
	{ label: '6-10 kg', value: '6-10kg', weight: 10, unit: 'kg' },
	{ label: '11-15 kg', value: '11-15kg', weight: 15, unit: 'kg' },
	// 'heavy' and 'unknown' are added dynamically with translated labels
];

// International letter options (7)
export const INTERNATIONAL_LETTER_OPTIONS: WeightOption[] = [
	{ label: '0-50 g', value: '0-50g', weight: 50, unit: 'g' },
	{ label: '51-100 g', value: '51-100g', weight: 100, unit: 'g' },
	{ label: '101-250 g', value: '101-250g', weight: 250, unit: 'g' },
	{ label: '251-500 g', value: '251-500g', weight: 500, unit: 'g' },
	{ label: '501-1000 g', value: '501-1000g', weight: 1000, unit: 'g' },
	{ label: '1001-1500 g', value: '1001-1500g', weight: 1500, unit: 'g' },
	{ label: '1501-2000 g', value: '1501-2000g', weight: 2000, unit: 'g' },
];

// Domestic letter options (3)
export const DOMESTIC_LETTER_OPTIONS: WeightOption[] = [
	{ label: '0-50 g', value: '0-50g', weight: 50, unit: 'g' },
	{ label: '51-250 g', value: '51-250g', weight: 250, unit: 'g' },
	{ label: '251-2000 g', value: '251-2000g', weight: 2000, unit: 'g' },
];
